import { Calculation, ComparisonNew, Interval, findChart } from "@/app/types"

// initial values to load
export const INITIAL_ENTITY = {
  entityType:
    process.env.NEXT_PUBLIC_INITIAL_ENTITY_TYPE ?
      process.env.NEXT_PUBLIC_INITIAL_ENTITY_TYPE
    : "fund",
  id:
    process.env.NEXT_PUBLIC_INITIAL_ENTITY_ID ?
      process.env.NEXT_PUBLIC_INITIAL_ENTITY_ID
    : "id9697", // ID 2/5/2024 - change to IQ 500 International ETF MSTAR:FS0000DPKO
}

export const INITIAL_TERM = {
  interval:
    process.env.NEXT_PUBLIC_INITIAL_TERM_INTERVAL ?
      process.env.NEXT_PUBLIC_INITIAL_TERM_INTERVAL
    : Interval.Monthly,
  key:
    process.env.NEXT_PUBLIC_INITIAL_TERM_KEY ?
      process.env.NEXT_PUBLIC_INITIAL_TERM_KEY
    : "3YR",
} // used to lookup the Term object

export const INITIAL_CHART = findChart(
  process.env.NEXT_PUBLIC_INITIAL_CHART ?
    process.env.NEXT_PUBLIC_INITIAL_CHART
  : "_2c_flows_cumulative_flows"
) // should be applicable to both funds and firms

export const INITIAL_CHART_RANKING = findChart("_2b_flows_net_flows_rank")

export const INITIAL_COMPARISON = ComparisonNew.getComparisonParameters(
  process.env.NEXT_PUBLIC_INITIAL_COMPARISON ?
    process.env.NEXT_PUBLIC_INITIAL_COMPARISON
  : ComparisonNew.PEERS,
  process.env.NEXT_PUBLIC_INITIAL_CALCULATION ?
    process.env.NEXT_PUBLIC_INITIAL_CALCULATION
  : Calculation.AVG
)
